module.exports = __webpack_public_path__ + "static/media/estate.4fb890fd.jpg";